<div class="login_form">
  <div class="text-center mb-4 pb-2">
    <p class="">Welcome To</p>
    <h1 class="tenMT">DeliveryPal</h1>
  </div>

  <div
    class="alert text-center mb-2"
    [ngClass]="alertClass"
    *ngIf="apiResponse"
  >
    {{ alertText }}
    <mat-icon (click)="apiResponse = false">close</mat-icon>
  </div>
  <div class="field-row">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="email" [formControl]="emailControl" />
      <mat-error *ngIf="emailControl.errors?.required && submitted"
        >Required</mat-error
      >
      <mat-error *ngIf="emailControl.errors?.email && submitted"
        >Please enter a valid email address</mat-error
      >
    </mat-form-field>
  </div>
  <div class="d-flex justify-content-center">
    <button
      mat-flat-button
      type="button"
      color="primary"
      class="login-btn"
      (click)="onSubmit()"
    >
      Submit
    </button>
  </div>
</div>
